import React, { useRef, useState, useEffect, useMemo } from 'react';
import CalendarioWidget from '../../compartedRoutes/Contabilidad/CalendarioWidget';
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad';
import LoadingWidget from '../../../components/Loadings/LoadingWidget';
import DialogEntregaModal from './Modulos/DialogEntrega';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { obtenerNombreEmpresaReal } from '../../../config/unificacion';

const CalendarioAdmin = () => {
  const calRef = useRef(null);

  const {
    servicios,
    loadingServicios,
    cargarServicios,
    setupWebSocketsServicios
  } = useContabilidadModel();

  const { configuracion } = useConfiguracion();
  const nombreEmpresaReal = obtenerNombreEmpresaReal(configuracion.nombreEmpresa);

  // Cargar servicios y conectar Sockets
  useEffect(() => {
    cargarServicios("", true);

    // Conectamos el socket pasando isAdmin = true para escuchar la sala masiva
    const socketCleanup = setupWebSocketsServicios(null, nombreEmpresaReal, 0, true);

    return () => {
        if (socketCleanup) socketCleanup();
    };
  }, []);

  // Modal states
  const [modalAbierto, setModalAbierto] = useState(false);
  const [servicioParaModal, setServicioParaModal] = useState(null);


  // Lógica de fechas para el header
  const obtenerFechasMes = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = ahora.getMonth();
    const primero = new Date(anio, mes, 1).toISOString().split('T')[0];
    const ultimo = new Date(anio, mes + 1, 0).toISOString().split('T')[0];
    return { primero, ultimo };
  };

  const { primero, ultimo } = obtenerFechasMes();
  const [fechaInicio, setFechaInicio] = useState(primero);
  const [fechaFinal, setFechaFinal] = useState(ultimo);

  const servicioClick = (servicio) => {
    setServicioParaModal(servicio);
    console.log("servicio click ",servicio);
    setModalAbierto(true);
  };

  if (loadingServicios) return <LoadingWidget mensaje={"Cargando servicios..."} />;

  return (
    <div className="flex flex-col w-full p-4 gap-4">
      
      {/* HEADER */}
      <div className="flex flex-wrap items-center justify-between gap-4 bg-gray-50 p-4 rounded-xl border border-gray-100 shadow-sm">
        <div className="flex items-center gap-2 bg-white p-2 rounded-lg border border-gray-200">
          <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} className="p-1.5 border-none text-sm outline-none" />
          <span className="text-gray-400">→</span>
          <input type="date" value={fechaFinal} onChange={(e) => setFechaFinal(e.target.value)} className="p-1.5 border-none text-sm outline-none" />
        </div>
        <button onClick={() => calRef.current?.getRangoVisible?.()} className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition-colors shadow-sm">
          Refrescar rango
        </button>
      </div>

      {/* CALENDARIO */}        
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <CalendarioWidget 
          ref={calRef}
          servicios={servicios} 
          onServicioClick={servicioClick}
          fechaInicio={fechaInicio}
          fechaFinal={fechaFinal}
        />
      </div>

      {/* MODAL SINCRONIZADO */}
      <DialogEntregaModal 
        abierto={modalAbierto} 
        alCerrar={() => setModalAbierto(false)} 
        servicio={servicioParaModal} // <--- Pasamos el servicio que viene del useMemo
      />

    </div>
  );
  
}

export default CalendarioAdmin;